'use client'

import type { AddToCartButtonProps } from '@maestro/commerce-blocks/components/add-to-cart-button/add-to-cart-button.types'

import { useAddToCartLoading } from '@/hooks/use-add-to-cart-loading'
import { useAddToCartButton } from '@maestro/commerce-blocks/components/add-to-cart-button/batons/use-add-to-cart-button'
import { Button } from '@pearlconvert/ui/components/button'

export default function AddToCartButton({
  product,
  variantId,
  title,
  className,
  type,
  size,
  openCart = false,
  notificationType = 'regular',
  isDisabled = false,
  validateSelection,
  error = null,
  hideTitle = false,
  url,
  eventProps,
  quantity,
}: AddToCartButtonProps) {
  const { ariaLabelText, handleAddToCart, isVisibleAddToCart, text } =
    useAddToCartButton({
      error,
      hideTitle,
      openCart,
      product,
      notificationType,
      title,
      validateSelection,
      variantId,
      eventProps,
      quantity,
    })
  const { handleAddToCartClick, isAdding } = useAddToCartLoading({
    handleAddToCart,
  })

  if (!isVisibleAddToCart) {
    return null
  }

  return (
    <Button
      testId="add-product-to-cart"
      className={className}
      disabled={isDisabled || isAdding}
      isLoading={isAdding}
      iconLeft="cart"
      type={type}
      size={size}
      title={text}
      ariaLabel={ariaLabelText}
      {...(url ? { url } : { onClick: handleAddToCartClick })}
    >
      {!hideTitle && text}
    </Button>
  )
}
